import { Dispatch } from 'redux';
import { getBuyerBudget } from '@/services/buyer-dashboard';
import { setBuyerBudget } from './actions';
import { IState } from '@/state/IState';

export function loadBuyerBudget() {
    return async function(dispatch: Dispatch, getState: () => IState) {
        const residentialUnitId = getState().buyer.permissions!.residentialUnitId;
        const budget = await getBuyerBudget(residentialUnitId);
        dispatch(setBuyerBudget(budget));
    };
}